import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index/index.component';
import {leaseRentalRouting} from "./lease-rental.routing";



@NgModule({
  declarations: [
    IndexComponent
  ],
  imports: [
    CommonModule,
    leaseRentalRouting
  ]
})
export class LeaseRentalModule { }
